module.exports = __webpack_public_path__ + "static/media/no-updates.e6ab3a6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/no-updates.svg
// module id = 807
// module chunks = 0